const contentMargins = ['16px', null, '24px'];
export const bleedMargins = ['-16px', null, '-24px'];

export default contentMargins;
